module.exports = __webpack_public_path__ + "img/vindome-mobile.6160c3a.png";